<app-campaign-calendar *ngIf="currentUser"></app-campaign-calendar>
<app-home *ngIf="!currentUser"></app-home>
